import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, sourceLabel: String }
  connect(){
    this.element.addEventListener('close', (event)=>{
      if (!this.element.returnValue) {
        this.dispatch("cancel", { detail: { id: this.idValue, sourceLabel: this.sourceLabelValue } });
      } else {
        this.dispatch('close', { detail: { } });
      }
    });
    this.element.showModal()
  }
}